import { styled } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import React from "react";

export default function CoverProductCard({ cover, id }) {
	const [imageUrl, setImageUrl] = React.useState(null);

	React.useEffect(() => {
		const fetchImageUrl = async (fileName) => {
			const res = await fetch(
				`/api/getCoverProduit?fileName=${fileName}`
			);
			const data = await res.json();
			return data.sasUrl;
		};

		if (cover) {
			fetchImageUrl(id + ".png").then((url) => {
				setImageUrl(url);
			});
		}
	}, [cover, id]);

	const StyledComponent = styled(CardMedia)(() => ({
		borderRadius: "1rem",
		position: "absolute",
		width: "100%",
		height: "100%",
		top: 0,
		left: 0,
		zIndex: 0,
		backgroundColor: "rgba(0, 0, 0, 0.08)",
		backgroundPosition: "center",
	}));

	return (
		<StyledComponent
			image={imageUrl ? imageUrl : "/img/default_product.jpeg"}
		/>
	);
}
